"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@material-ui/core");
exports.whiteKTRTheme = core_1.createMuiTheme({
    overrides: {
        MuiMenu: {
            paper: {
                backgroundColor: "#fff",
            }
        },
        MuiMenuItem: {
            gutters: {
                backgroundColor: "#fff",
            },
        },
        MuiTouchRipple: {
            childPulsate: {
                backgroundColor: "#fff",
            }
        },
        MuiContainer: {
            maxWidthLg: {
                maxWidth: "1100px !important"
            }
        }
    },
    shape: {
        borderRadius: 0,
    },
    palette: {
        primary: {
            main: '#666666',
            light: '#ffffff'
        },
        background: {
            default: '#fff',
            paper: "#E6E6E6"
        },
        secondary: {
            main: '#8F8F8F',
            light: '#555555'
        },
        third: {
            main: '#F29400'
        },
        text: {
            primary: '#707070',
            secondary: '#ffffff'
        }
    },
    typography: {
        fontFamily: 'Arial',
    }
});
exports.whiteKTRTheme.overrides = {
    ...exports.whiteKTRTheme.overrides,
    MuiCardHeader: {
        root: {
            backgroundColor: exports.whiteKTRTheme.palette.background.default,
            padding: "5px",
        },
        title: {
            fontSize: "1.0rem"
        }
    },
    MuiCard: {
        root: {
            borderColor: exports.whiteKTRTheme.palette.secondary.main,
            backgroundColor: "#fff",
            border: "none",
            boxShadow: "0 0 7px rgba(0,0,0,0.08), 1px 3px 15px rgba(0,0,0,0.2);"
        }
    },
    MuiButton: {
        root: {
            border: "none",
            backgroundColor: exports.whiteKTRTheme.palette.third.main,
            '&:hover': {
                backgroundColor: exports.whiteKTRTheme.palette.secondary.main,
            },
            minWidth: "100px",
            minHeight: "30px",
            color: exports.whiteKTRTheme.palette.text.secondary,
            fontWeight: "bold"
        }
    },
    MuiSelect: {
        root: {
            color: exports.whiteKTRTheme.palette.text.primary,
            '&:focus': {
                backgroundColor: "rgba(0, 0, 0, 0) !important",
            }
        }
    },
    MuiRadio: {
        colorSecondary: {
            color: exports.whiteKTRTheme.palette.secondary.main,
        },
        root: {
            padding: "3px",
            margin: "0px",
        },
        input: {
            margin: "0px"
        }
    },
    MuiCheckbox: {
        checked: {},
    },
    MuiIcon: {
        root: {}
    },
    MuiAutocomplete: {
        option: {
            padding: "0px",
            margin: "0px",
        },
        listbox: {
            backgroundColor: "#fff",
        },
    },
    MuiListItem: {
        selected: {
            backgroundColor: exports.whiteKTRTheme.palette.third.main + "!important"
        },
        divider: {
            borderBottom: "1px solid rgba(255, 255, 255, 1)"
        }
    },
    MuiInput: {
        root: {
            border: "1.4px solid",
            borderColor: exports.whiteKTRTheme.palette.secondary.main,
            paddingLeft: "10px",
            fontSize: "0.8rem",
            boxShadow: "0 0 7px rgba(0,0,0,0.08), 0 3px 8px rgba(0,0,0,0.08);"
        },
        error: {
            borderColor: "red"
        },
        disabled: {
            backgroundColor: exports.whiteKTRTheme.palette.background.paper,
            color: exports.whiteKTRTheme.palette.text.primary,
        }
    },
    MuiFormHelperText: {
        root: {
            color: exports.whiteKTRTheme.palette.text.primary
        }
    },
    MuiFormLabel: {
        root: {
            color: exports.whiteKTRTheme.palette.secondary.main,
            fontSize: "1.0em",
            paddingLeft: "10px",
        }
    },
    MuiTableHead: {
        root: {}
    },
    MuiTableCell: {
        head: {
            color: exports.whiteKTRTheme.palette.third.main,
            fontWeight: "bold",
            textTransform: "uppercase",
            borderBottom: "3px solid",
            borderBottomColor: exports.whiteKTRTheme.palette.primary.main,
            backgroundColor: "transparent",
        }
    },
    MuiTableRow: {
        head: {
            '&:nth-of-type(odd)': {
                backgroundColor: "transparent",
            },
        },
        root: {
            '&:nth-of-type(even)': {
                backgroundColor: exports.whiteKTRTheme.palette.background.paper,
            },
        }
    },
    MuiSlider: {
        thumb: {
            marginTop: "-4px",
            height: "13px",
            width: "13px",
            color: exports.whiteKTRTheme.palette.third.main
        },
        track: {
            height: "5px",
            color: exports.whiteKTRTheme.palette.third.main
        },
        rail: {
            height: "5px",
            borderRadius: "25px"
        }
    },
    MuiList: {
        root: {},
        padding: {
            paddingTop: "0px",
            paddingBottom: "0px"
        },
    },
    MuiTooltip: {
        arrow: {
            color: exports.whiteKTRTheme.palette.third.main
        },
        tooltip: {
            backgroundColor: exports.whiteKTRTheme.palette.third.main,
            fontSize: "0.9em"
        }
    }
};
exports.blackKTRTheme = core_1.createMuiTheme({
    palette: {
        primary: {
            main: '#666666',
            light: '#ffffff'
        },
        background: {
            default: '#000',
            paper: "#353535"
        },
        secondary: {
            main: '#878787',
            light: '#555555'
        },
        third: {
            main: '#F29400'
        },
        text: {
            primary: '#fff',
            secondary: '#ffffff'
        }
    },
    typography: {
        fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif'
    }
});
//# sourceMappingURL=Theme.js.map